import './style.css';
import React, { useEffect, useState } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import lefticon from '../../Assets/Images/left.png';
import { failed } from '@components/Common/Toastify';
import borrowerImg1 from '../../Assets/Images/borrwr-img-one.png';
import borrowerImg2 from '../../Assets/Images/borrwr-img-two.png';
import borrowerImg3 from '../../Assets/Images/borrwr-img-three.png';
import borrowerImg4 from '../../Assets/Images/borrwr-img-four.png';
import borrowerImg5 from '../../Assets/Images/borrwr-img-five.png';
import lenderImg1 from '../../Assets/Images/banner-one.png';
import lenderImg2 from '../../Assets/Images/banner-two.png';
import lenderImg3 from '../../Assets/Images/banner-3.png';
import lenderImg4 from '../../Assets/Images/banner-four.png';
import lenderImg5 from '../../Assets/Images/banner-five.png';
import lendriva_logo from '../../Assets/Images/Lendriva_logo.jpg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { documentVerification, getVerificationStatus } from "../../API/Auth";
import righticon from "../../Assets/Images/right-icon.png";
import 'swiper/css';
import 'swiper/css/pagination';
import storage from '@utils/storage';
import envConfig from '../../environment';
import axios from 'axios';

export const DocumentVerification = () => {
    const navigate = useNavigate();
    const SHUFTIPRO_CLIET_ID = envConfig.SHUFTIPRO_CLIET_ID;
    const SHUFTIPRO_SECRET_KEY = envConfig.SHUFTIPRO_SECRET_KEY;
    const Id = storage.getUserType();
    const role = Id?.userType;
    const [selectedFile, setSelectedFile] = useState(null);
    const location = useLocation();
    const userDataFromState = location.state?.userData
    const roleTypeFromState = location.state?.roleType;
    const initialUserData = userDataFromState ?? Id;
    const roleType = roleTypeFromState ?? role;
    const [userData, setUserData] = useState(initialUserData);
    const [declineError, setDeclineError] = useState('');
    const [isVerificationApproved, setIsVerificationApproved] = useState(false);
    const [shuftiReference, setShuftiReference] = useState<string | null>(null);

    const [selectedUserType, setSelectedUserType] = useState<
        "borrower" | "lender"
    >("borrower");
    const borrowerImages = [borrowerImg1, borrowerImg2, borrowerImg3, borrowerImg4, borrowerImg5];
    const lenderImages = [lenderImg1, lenderImg2, lenderImg3, lenderImg4, lenderImg5];
    const [, setCurrentImageIndex] = useState(0);
    const [btnLoading, setBtnLoading] = useState(false);

    const userId = userData?.uuid || userData?.data?.uuid || userData?.userId;

    const handleDocumentSkipSuccess = (data: Record<string, unknown>) => {
        const user = {
            ...userData,
            uuid: data.uuid || userId,
            email: data.email ?? userData?.email,
            phoneNumber: data.phoneNumber ?? userData?.phoneNumber,
            userType: data.userType ?? roleType,
        };
        storage.setUserType(user);
        setUserData(user);
        setIsVerificationApproved(true);

        if (envConfig.SKIP_DOCUMENT_VERIFICATION) {
            navigate("/auth/credit-score-assessment", {
                state: { roleType, userData: user },
            });
        }
    };


    useEffect(() => {
        const loginPage = document.querySelector(".onboarding-page");
        if (loginPage) {
            loginPage.classList.remove("theme-borrower", "theme-lender");
            loginPage.classList.add(`theme-${roleType}`);
        }
    }, [roleType]);

    useEffect(() => {
        if (roleType === "borrower" || roleType === "lender") {
            setSelectedUserType(roleType);
        }
    }, [roleType]);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex(
                (prevIndex) =>
                    (prevIndex + 1) %
                    (roleType === "borrower"
                        ? borrowerImages.length
                        : lenderImages.length)
            );
        }, 5000);
        return () => clearInterval(interval);
    }, [borrowerImages.length, lenderImages.length, roleType]);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setSelectedFile(e.target.files[0]);
        }
    };

    const handleSubmit = async (e: { preventDefault: () => void }) => {
        e.preventDefault();

        setBtnLoading(true);

        try {
            const res = await documentVerification({
                userId: userId,
                userType: roleType,
                file: selectedFile,
            });
            const { data } = res.data;

            if (data?.skipped) {
                handleDocumentSkipSuccess(data);
                return;
            }

            if (data?.reference) {
                setShuftiReference(data.reference);
            }

            if (data?.verificationUrl) {
                window.location.href = data.verificationUrl;
            }
        } catch (err) {
            failed(err?.response?.data?.message || "Something went wrong");
        } finally {
            setBtnLoading(false);
        }
    };

    useEffect(() => {
        if (
            envConfig.SKIP_DOCUMENT_VERIFICATION &&
            userId &&
            !isVerificationApproved &&
            !btnLoading
        ) {
            setBtnLoading(true);
            documentVerification({
                userId,
                userType: roleType,
            })
                .then((res: any) => {
                    const { data } = res.data;
                    if (data?.skipped) {
                        handleDocumentSkipSuccess(data);
                    }
                })
                .catch((err) => {
                    failed(err?.response?.data?.message || "Something went wrong");
                })
                .finally(() => setBtnLoading(false));
        }
    }, []);

    useEffect(() => {
        let isMounted = true;
        let pollCount = 0;
        const maxPolls = 30; // 90 seconds max
        let intervalId: any = null;

        const checkStatus = async () => {
            if (!userId) return;
            try {
                const response = await getVerificationStatus(userId);
                const data = response.data?.data;
                if (data?.isDocumentsVerified && isMounted) {
                    setIsVerificationApproved(true);
                    if (intervalId) clearInterval(intervalId);
                }
            } catch (error) {
                console.error("Error fetching verification status from backend:", error);
            }
        };

        if (userId) {
            checkStatus();

            intervalId = setInterval(() => {
                pollCount++;
                if (pollCount >= maxPolls) {
                    if (intervalId) clearInterval(intervalId);
                } else {
                    checkStatus();
                }
            }, 3000);
        }

        return () => {
            isMounted = false;
            if (intervalId) clearInterval(intervalId);
        };
    }, [userId]);

    useEffect(() => {
        if (isVerificationApproved) {
            const timer = setTimeout(() => {
                navigate("/auth/credit-score-assessment", {
                    state: { roleType, userData },
                });
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [isVerificationApproved, navigate, roleType, userData]);





    return (
        <div className="">
            <div className="row onboarding-page fg-pw theme-borrower">
                {/* <div className="col-lg-6 bg-image p-0">
                    <div className="swiper-inner position-relative">
                        <Swiper
                            pagination={true}
                            modules={[Pagination]}
                            className="swiper-block"
                            onSlideChange={(swiper) => setCurrentImageIndex(swiper.activeIndex)}
                        >
                            {(selectedUserType === "borrower" ? borrowerImages : lenderImages).map(
                                (imgSrc, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="slider-images-block">
                                            <div className="slider-banner">
                                                <img src={imgSrc} alt="" className="img-fluid w-100" />
                                            </div>
                                            <div className="lendriva-logo-auth position-absolute">
                                                <img src={lendriva_logo} alt="" className="img-fluid" />
                                            </div>
                                            <div className="overlay-content text-center">
                                                <h5 className="overlay-heading">Welcome to Lendriva!</h5>
                                                <p className="overlay-heading">
                                                    Empowering Your Financial Journey with Community Support
                                                </p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                )
                            )}
                        </Swiper>
                    </div>
                </div> */}

                <div className="p-0 d-flex flex-column align-items-center my-3">
                    <div className="login-btn-call align-items-center d-flex justify-content-between">
                        <div className="return-home">
                            <Link
                                to="/auth/login"
                                state={{ roleType }}
                                className="return text-decoration-none align-ittems-center d-flex"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="23"
                                    height="23"
                                    style={{ display: 'block', filter: 'brightness(0) invert(1)' }}
                                >
                                    <path
                                        d="M15.41 7.41 10.83 12l4.58 4.59L14 18l-6-6 6-6z"
                                        fill="#000000"
                                    />
                                </svg>
                                <span className="ms-2 text-decoration-none">Back</span>
                            </Link>
                        </div>
                    </div>
                    <div className="lower-div">
                        <div className="credentials-box">
                            {!isVerificationApproved && (
                                <div className="heading-para-block">
                                    <h2 className="text-center">Upload Document for Verification</h2>
                                    <p className="text-center enter-address">Please select a valid ID document for Stripe verification.</p>
                                </div>
                            )}
                            {/* If Verified, show success message and login link */}
                            {isVerificationApproved ? (
                                <div className="text-center mt-3">
                                    <div className="d-flex flex-column gap-4 align-items-center justify-content-center mb-4">
                                        <div>
                                            <span className="me-2"><img src={righticon} alt="" /></span>
                                        </div>
                                        <h4 >Document Verified Successfully</h4>
                                    </div>
                                    <div className="btn btn-borrower proceed-button signin w-100">
                                        <Link
                                            className="text-decoration-none text-white"
                                            to="/auth/credit-score-assessment"
                                            state={{ roleType, userData }}
                                        >
                                            Proceed to Credit Assessment
                                        </Link>
                                    </div>

                                </div>
                            ) : (
                                <>
                                    <form className="onboarding-form" onSubmit={handleSubmit}>
                                        <div className="mb-4">
                                            <label htmlFor="document" className="form-label">
                                                Upload Document <span className="text-orange">*</span>
                                            </label>
                                            <input
                                                type="file"
                                                id="document"
                                                accept="image/*,application/pdf"
                                                onChange={handleFileChange}
                                                className="form-control"
                                            />
                                        </div>
                                        <button
                                            type="submit"
                                            className="btn btn-borrower signin w-100"
                                            disabled={btnLoading}
                                        >
                                            {btnLoading ? "Verifying..." : "Upload Document"}
                                        </button>
                                    </form>
                                </>
                            )}
                            {/* Decline error shown right below the instructions */}
                            {declineError && (
                                <div className="text-danger mt-2 text-center">
                                    {declineError}
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentVerification;
